module.exports = __webpack_public_path__ + "img/chips5.b49d8596.png";